import {
    Constraint_Stacks,
    GetConstraintsQuery,
    Maybe
} from "generated/graphql";
import { BusId } from "./busType";
import { withKnownScopeViews } from "./knownScopeViews";
import { convertToResourceType, ResourceType } from "./resourceType";
import { ScopeName } from "./scope";
import { convertToScopeViewType, ScopeViewType } from "./scopeViewType";

export type SolutionId = string;

type HasuraConstraint = Readonly<
    Pick<
        Constraint_Stacks,
        | "bus_id"
        | "injection_threshold"
        | "monitored_facility_name"
        | "resource_type"
        | "rating"
        | "pre_study_load"
        | "element_type"
        | "line_length"
        | "dfax"
        | "monitored_facility_id"
        | "estimated_cost"
        | "scope"
        | "scope_view"
        | "contingency"
        | "contingency_buses"
        | "contingency_type"
    >
>;

export type Constraint = {
    readonly busId: BusId;
    readonly injectionThreshold: number;
    readonly monitoredFacilityId: string;
    readonly monitoredFacilityName: string;
    readonly resourceType: ResourceType;
    readonly rating: number;
    readonly preStudyLoad: number;
    readonly elementType: string;
    readonly lineLength: number | undefined;
    readonly dfax: number;
    readonly estimatedCost: number | undefined;
    readonly scope: ScopeName;
    readonly scopeView: ScopeViewType;
    readonly contingency: string;
    readonly contingencyType: string | undefined;
    readonly contingencyBuses: string | undefined;
};

const convertHasuraConstraintToConstraint = (
    hasuraConstraint: HasuraConstraint
): Constraint => {
    return {
        busId: hasuraConstraint.bus_id,
        injectionThreshold: hasuraConstraint.injection_threshold,
        monitoredFacilityId: hasuraConstraint.monitored_facility_id,
        monitoredFacilityName: hasuraConstraint.monitored_facility_name,
        resourceType: convertToResourceType(hasuraConstraint.resource_type),
        rating: hasuraConstraint.rating,
        preStudyLoad: hasuraConstraint.pre_study_load,
        elementType: hasuraConstraint.element_type,
        lineLength: convertMaybeToUndefined(hasuraConstraint.line_length),
        dfax: hasuraConstraint.dfax,
        estimatedCost: convertMaybeToUndefined(hasuraConstraint.estimated_cost),
        scope: hasuraConstraint.scope,
        scopeView: convertToScopeViewType(hasuraConstraint.scope_view),
        contingency: hasuraConstraint.contingency,
        contingencyType: convertMaybeToUndefined(
            hasuraConstraint.contingency_type
        ),
        contingencyBuses: convertMaybeToUndefined(
            hasuraConstraint.contingency_buses
        )
    };
};

export const convertHasuraConstraintsToConstraints = (
    hasuraData: GetConstraintsQuery
): ReadonlyArray<Constraint> => {
    return withKnownScopeViews(
        hasuraData.constraint_stacks,
        "constraint_stacks"
    ).map(convertHasuraConstraintToConstraint);
};

const convertMaybeToUndefined = <T,>(
    maybeValue: Maybe<T> | undefined
): T | undefined => {
    if (maybeValue === null || maybeValue === undefined) {
        return undefined;
    } else {
        return maybeValue;
    }
};
